import { ResumeDto } from "@reactive-resume/dto";

const getClearCustomFields = (data: ResumeDto) => {
  const result: ResumeDto = {
    ...data,
  };
  result.data.basics.customFields = data.data.basics.customFields.filter((item) => !!item.value);
  return result;
};

export default getClearCustomFields;
